/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";

/** @module core/modules/object-utils/truncate */
import { forEachSync } from './for-each-sync.js';
import { getKeys } from './get-keys.js';
import { hasKeys } from './has-keys.js';
import { isPureObject } from './is-pure-object.js';
/**
 * @description Truncates and object to the specified depth, replacing any remaining branches with a string representation including type and keys.
 * @param {(Object<string,*>|Array<*>)} obj - Input object.
 * @param {number} maxDepth - Truncation depth.
 * @returns {Object<string,*>} Resulting object.
 */

function truncate(obj, maxDepth) {
  var _this = this,
      _context;

  obj = forEachSync(obj, _bindInstanceProperty(_context = function _context(elem, API) {
    _newArrowCheck(this, _this);

    if (API.depth === maxDepth) {
      if (_Array$isArray(elem)) {
        API.replaceValue("[ARRAY: ".concat(getKeys(elem).join(' '), "]"));
      } else if (isPureObject(elem)) {
        API.replaceValue("[OBJECT: ".concat(getKeys(elem).join(' '), "]"));
      } else if (hasKeys(elem)) {
        var _context2;

        API.replaceValue(_concatInstanceProperty(_context2 = "[".concat(_typeof(elem).toUpperCase(), ": ")).call(_context2, getKeys(elem).join(' '), "]"));
      }
    }
  }).call(_context, this), {
    maxDepth: maxDepth,
    circularCheck: true
  });
  return obj;
}

export { truncate };